import React, {useState, useEffect} from 'react'
import {
  flexRender,
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  getFilteredRowModel,
} from '@tanstack/react-table'
import TablePagination from '../../../components/TablePagination/TablePagination'
import notifyToast from '../../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'
import {KTCard, KTCardBody, KTIcon} from '../../../../_websoft/helpers'
import TableSearch from '../../../components/TableSearch/TableSearch'
import ExportButton from '../../../components/TableExportToExcel/ExportButton'
import {Link} from 'react-router-dom'
import {TableActionButton} from '../../../components/TableActionBtn/TableActionButton'
import {useNavigate} from 'react-router-dom'
import LoadingComponent from '../../../components/LoadingComponent/LoadingComponent'
import {PrijavaKvaraModel} from '../../../models/PrijavaKvara'
import moments from 'moment/moment'
import {PaginationModel} from '../../../models/PaginationModel'
import {getMojeIntervencije} from '../../../api/intervencijeOdrzavanja'
import {ParamsModelMojeIntervencije} from '../../../models/IntervencijeOdrzavanja'

const MojeIntervencije: React.FC = () => {
  const [data, setData] = useState<PrijavaKvaraModel[]>([])
  const [loading, setLoading] = useState(true)
  const [pagination, setpagination] = useState<PaginationModel>({
    curPage: 1,
    totalPage: 1,
    perPage: 10,
  })
  const getKorisnikId = () => {
    try {
      const storedData = localStorage.getItem('kt-auth-react-v')
      if (storedData) {
        const parsedData = JSON.parse(storedData)
        return parsedData.UposlenikId
      }
    } catch (error) {
      console.error('Error reading from local storage:', error)
    }
    return null
  }

  const korisnik = getKorisnikId()

  const [filter, setfilter] = useState('')
  const [params, setparams] = useState<ParamsModelMojeIntervencije>({
    uposlenik: korisnik,
    per_page: 10,
    page: 1,
  })

  const [sorting, setSorting] = useState<SortingState>([])
  const [globalFilter, setGlobalFilter] = React.useState('')

  const updatePage = () => {
    setLoading(true)
    getMojeIntervencije(params)
      .then((response) => {
        const data = response.data['data']
        setData(data)
        const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
        setpagination({
          curPage: response.data['current_page'],
          totalPage: totalPage,
          perPage: params.per_page,
        })
      })
      .catch((error) => {
        console.error('Error: ', error)
        notifyToast(false, error)
      })
      .finally(() => {
        setLoading(false)
      })
    console.log(data)
  }

  useEffect(() => {
    updatePage()
  }, [params])

  useEffect(() => {
    const {id} = sorting[0] ?? ''
    data.sort((a, b) => a[id] - b[id])
  }, [sorting])

  const columns = [
    {
      id: 'Id',
      header: 'Id',
      accessorKey: 'Id',
    },
    {
      id: 'Broj Intervencije',
      header: 'Broj Intervencije',
      accessorKey: 'intervencija.BrojIntervencije',
    },
    {
      id: 'Datum',
      header: 'Datum',
      accessorFn: (row) => `${moments(row.intervencija.Datum).format('DD-MM-YYYY')}`,
    },
    {
      id: 'Sredstvo naziv',
      header: 'Sredstvo naziv',
      accessorKey: 'intervencija.sredstvo.SredstvoNaziv',
    },
    {
      id: 'Opis radova',
      header: 'Opis radova',
      accessorKey: 'intervencija.OpisRadova',
    },
    {
      id: 'Voditelj',
      header: 'Voditelj',
      accessorKey: 'intervencija.uposlenik.UposlenikImePrezime',
    },
    {
      id: 'Status',
      header: 'Status',
      accessorKey: 'Status',
      cell: ({row}: {row: any}) => (
        <div
          style={{
            backgroundColor: row.original.intervencija.status.Boja,
            padding: '15px',
          }}
        >
          {row.original.intervencija.status.Naziv}
        </div>
      ),
    },
  ]
  const table = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting: sorting,
      globalFilter: globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    onSortingChange: setSorting,
  })

  const navigate = useNavigate()

  return (
    <KTCard>
      <ToastContainer />
      <KTCardBody className='py-4'>
        <div className='d-flex justify-content-between'>
          <div data-kt-user-table-toolbar='base'>
            <TableSearch onSearch={(text) => setGlobalFilter(text)} />
          </div>
          <div data-kt-user-table-toolbar='base'>
            {/*     <ExportButton table={table} filename={'sredstva_lista'} />
                        <Link to='/prijava-kvara/dodaj'>
                            <button type='button' className='btn btn-primary'>
                                <KTIcon iconName='plus' className='fs-2' />
                                Dodaj prijavu kvara
                            </button>
                        </Link>*/}
          </div>
        </div>
        {loading ? (
          <LoadingComponent />
        ) : (
          <div className='table-responsive mt-3 '>
            <table className='table align-middle table-bordered gy-5 no-footer'>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr
                    key={headerGroup.id}
                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                  >
                    {headerGroup.headers.map((header) => (
                      <th
                        className='text-white'
                        key={header.id}
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {/* @ts-ignore */}
                        {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className='text-gray-600'>
                {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                  table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No matching records found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        <TablePagination
          updatePage={(page, per_page) => setparams({...params, page: page, per_page: per_page})}
          pagination={pagination}
        />
      </KTCardBody>
    </KTCard>
  )
}
export default MojeIntervencije
